/* eslint-disable camelcase */
import {
  countries,
  DropDownMenu,
  minLength8,
  required,
  TextField,
} from 'entoro-shared';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import parser from 'parse-address';
import {
  PhoneNumberInput,
  validatePhone,
} from '../../FormFields/PhoneNumberInput';

const BasicInformationForm = reduxForm({
  form: 'basicInformation',
  enableReinitialize: true,
})((props) => {
  const { handleSubmit, submitting, update, requireAddressDetail } = props;

  return (
    <div className='form-block w-form'>
      <form
        name='email-form-2'
        data-name='Email Form 2'
        className='w-clearfix'
        onSubmit={handleSubmit((values) => {
          const { street, city, state, zip } = values;

          const newAddress = `${street}, ${city}, ${state}, ${zip}`;

          update({
            ...values,
            address: newAddress,
          });
        })}
      >
        <div className='form-chunk-container w-clearfix'>
          <div className='_26-black'>Name</div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={[required]}
              name='firstName'
              label='First Name'
              autoComplete='given-name'
              required
            />
          </div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={[required]}
              name='lastName'
              label='Last Name'
              autoComplete='family-name'
              required
            />
          </div>
        </div>
        <div className='form-chunk-container w-clearfix'>
          <div className='_26-black'>Credentials</div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              name='email'
              label='Email'
              type='email'
              disabled
            />
          </div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={[minLength8]}
              name='password'
              label='Password'
              type='password'
              autoComplete='new-password'
            />
          </div>
        </div>
        <br />
        <div className='form-chunk-container w-clearfix'>
          <div className='_26-black'>Contact Information</div>
          <div className='form-fields-container'>
            <Field
              component={PhoneNumberInput}
              validate={[required, validatePhone]}
              name='officePhoneNumber'
              label='Office Phone Number'
              required
            />
          </div>
          <div className='form-fields-container'>
            <Field
              component={PhoneNumberInput}
              name='mobilePhoneNumber'
              label='Mobile Phone Number'
            />
          </div>
        </div>
        <div className='form-chunk-container w-clearfix'>
          <div className='_26-black'>Location</div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={[required]}
              name='companyName'
              label='Company'
              required
            />
          </div>
          <div className='form-fields-container'>
            <Field
              component={DropDownMenu}
              validate={[required]}
              name='country'
              label='Country'
              options={countries.options}
              required
            />
          </div>
        </div>
        <br />
        <div className='form-chunk-container w-clearfix'>
          <div className='_26-black'>Address</div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={[required]}
              name='street'
              label='Street'
              required
            />
          </div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={requireAddressDetail ? [required] : null}
              name='city'
              label='City'
              required={requireAddressDetail}
            />
          </div>
        </div>
        <div className='form-chunk-container w-clearfix'>
          <div className='_26-black' />
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={requireAddressDetail ? [required] : null}
              name='state'
              label='State'
              required={requireAddressDetail}
            />
          </div>
          <div className='form-fields-container'>
            <Field
              component={TextField}
              validate={requireAddressDetail ? [required] : null}
              name='zip'
              label='Zip or City Code'
              required={requireAddressDetail}
            />
          </div>
        </div>

        <div className='full-line' />
        <input
          type='submit'
          value='Save & Continue'
          disabled={submitting}
          className={`button-2 w-button ${submitting ? 'btn-disabled' : ''}`}
        />
      </form>
    </div>
  );
});

const mapStateToProps = (state) => {
  const { investorUser = {} } = state;
  const { country, address: savedAddress } = investorUser;
  console.log(
    '🚀 ~ file: BasicInformationForm.js:187 ~ mapStateToProps ~ savedAddress:',
    savedAddress
  );

  const selector = formValueSelector('basicInformation');

  const {
    number = '',
    prefix = '',
    street = '',
    type = '',
    zip = '',
    city = '',
    state: parsedState = '',
    sec_unit_type = '',
    sec_unit_num = '',
  } = parser.parseLocation(savedAddress);

  // const parsedAddress1 = `${number} ${prefix} ${street} ${type}`
  //   .replace(/\s+/g, ' ')
  //   .trim();
  // const parsedAddress2 = `${sec_unit_type} ${sec_unit_num}`
  //   .replace(/\s+/g, ' ')
  //   .trim();
  // const parsedAddress = `${parsedAddress1} ${parsedAddress2}`;

  function parseAddress(address) {
    // Check if address is passed
    if (!address) {
      return {
        street: '',
        city: '',
        state: '',
        zipcode: '',
      };
    }

    // The format is expected as: [street], [city], [state], [zipcode]
    const parts = address.split(',');

    // Guard clause to avoid errors with addresses in wrong format
    if (parts.length !== 4) {
      console.error('Address in wrong format');
      return {
        street: '',
        city: '',
        state: '',
        zipcode: '',
      };
    }

    const addressParts = {
      street: parts[0],
      city: parts[1],
      state: parts[2],
      zipcode: parts[3],
    };

    return addressParts;
  }

  const addressParts = parseAddress(savedAddress);

  const initialValues = {
    ...investorUser,
    street: addressParts.street,
    city: addressParts.city,
    state: addressParts.state,
    zip: addressParts.zipcode,
    country: country || 'US',
  };

  return {
    initialValues,
    requireAddressDetail: selector(state, 'country') === 'US',
  };
};

export default connect(mapStateToProps)(BasicInformationForm);



// WEBPACK FOOTER //
// ./src/components/Account/BasicInformation/BasicInformationForm.js